import { useMutation, useQueryClient } from "@tanstack/react-query"

import { type ContentDeleteTopicResponse, ContentService } from "@/client"
import type { ApiError } from "@/client/core/ApiError"

export function useDeleteTopic() {
  const queryClient = useQueryClient()

  return useMutation<
    ContentDeleteTopicResponse,
    ApiError,
    { topicId: string; onSuccess?: () => void }
  >({
    mutationFn: ({ topicId }) => ContentService.deleteTopic({ topicId }),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["admin-topics"] })
      if (variables.onSuccess) {
        variables.onSuccess()
      }
    },
  })
}
